var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamilySupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 404,
    viewBox: "0 0 450 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.153 90.157C62.438 90.157 43.143 69.9519 43.143 45.1149C43.143 20.2809 62.439 0.0749512 86.153 0.0749512C109.868 0.0749512 129.163 20.2809 129.163 45.1149C129.164 69.9519 109.868 90.157 86.153 90.157ZM86.153 15.512C70.946 15.512 58.579 28.7919 58.579 45.1149C58.579 61.4399 70.946 74.7209 86.153 74.7209C101.36 74.7209 113.727 61.4399 113.727 45.1149C113.727 28.7919 101.36 15.512 86.153 15.512Z",
    fill: "url(#paint0_linear_1744_1286)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.153 403.924C81.89 403.924 78.435 400.469 78.435 396.206V265.964C78.435 261.701 81.89 258.246 86.153 258.246C90.416 258.246 93.871 261.701 93.871 265.964V396.206C93.871 400.469 90.416 403.924 86.153 403.924Z",
    fill: "url(#paint1_linear_1744_1286)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.582 403.924H46.719C42.456 403.924 39.001 400.469 39.001 396.206V262.937C35.431 264.655 31.44 265.62 27.219 265.62C12.21 265.62 0 253.41 0 238.395V150.783C0 125.018 20.959 104.058 46.719 104.058H124.261C131.032 101.574 168.345 86.783 204.915 50.191C214.695 40.408 230.427 39.525 241.497 48.126C252.803 56.923 255.679 71.425 248.485 83.388C230.016 114.089 190.31 149.989 133.299 161.142V396.205C133.299 400.469 129.845 403.924 125.582 403.924ZM54.437 388.488H117.864V154.673C117.864 150.878 120.625 147.645 124.376 147.052C179.639 138.288 217.892 104.31 235.257 75.433C238.392 70.217 237.127 64.281 232.019 60.314C227.069 56.461 220.122 56.814 215.829 61.107C172.855 104.108 129.791 118.522 127.982 119.113C127.204 119.367 126.396 119.496 125.583 119.496H46.719C29.468 119.496 15.436 133.533 15.436 150.785V238.397C15.436 244.897 20.724 250.186 27.219 250.186C33.713 250.186 39.001 244.898 39.001 238.397C39.001 234.134 42.456 230.679 46.719 230.679C50.982 230.679 54.437 234.134 54.437 238.397V388.488Z",
    fill: "url(#paint2_linear_1744_1286)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.719 246.114C42.456 246.114 39.001 242.659 39.001 238.396V172.19C39.001 167.926 42.456 164.472 46.719 164.472C50.982 164.472 54.437 167.927 54.437 172.19V238.396C54.437 242.658 50.982 246.114 46.719 246.114Z",
    fill: "url(#paint3_linear_1744_1286)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M363.847 90.157C340.132 90.157 320.837 69.9519 320.837 45.1149C320.837 20.2809 340.132 0.0749512 363.847 0.0749512C387.562 0.0749512 406.857 20.2809 406.857 45.1149C406.857 69.9519 387.562 90.157 363.847 90.157ZM363.847 15.512C348.64 15.512 336.273 28.7919 336.273 45.1149C336.273 61.4399 348.64 74.7209 363.847 74.7209C379.054 74.7209 391.421 61.4399 391.421 45.1149C391.421 28.7919 379.055 15.512 363.847 15.512Z",
    fill: "url(#paint4_linear_1744_1286)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M363.847 403.924C359.584 403.924 356.129 400.469 356.129 396.206V265.964C356.129 261.701 359.584 258.246 363.847 258.246C368.11 258.246 371.565 261.701 371.565 265.964V396.206C371.565 400.469 368.11 403.924 363.847 403.924Z",
    fill: "url(#paint5_linear_1744_1286)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M403.276 403.924H324.413C320.15 403.924 316.695 400.469 316.695 396.206V161.143C266.504 151.326 234.328 123.213 219.321 106.884C216.432 103.745 216.638 98.861 219.779 95.976C222.915 93.103 227.798 93.296 230.681 96.434C244.977 111.982 276.314 139.227 325.625 147.051C329.369 147.645 332.131 150.877 332.131 154.672V388.488H395.558V238.395C395.558 234.132 399.013 230.677 403.276 230.677C407.539 230.677 410.994 234.132 410.994 238.395C410.994 244.895 416.282 250.184 422.782 250.184C429.276 250.184 434.564 244.896 434.564 238.395V150.783C434.564 133.532 420.526 119.494 403.276 119.494H324.413C323.599 119.494 322.791 119.365 322.013 119.111C320.946 118.761 295.494 110.289 264.23 87.063C260.805 84.522 260.093 79.686 262.632 76.264C265.183 72.848 270.018 72.134 273.432 74.672C299.173 93.792 320.735 102.243 325.728 104.058H403.277C429.042 104.058 450.001 125.017 450.001 150.783V238.395C450.001 253.409 437.791 265.619 422.783 265.619C418.562 265.619 414.564 264.654 410.995 262.93V396.205C410.994 400.469 407.539 403.924 403.276 403.924Z",
    fill: "url(#paint6_linear_1744_1286)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M403.276 246.114C399.012 246.114 395.558 242.659 395.558 238.396V172.19C395.558 167.926 399.013 164.472 403.276 164.472C407.539 164.472 410.994 167.927 410.994 172.19V238.396C410.994 242.658 407.539 246.114 403.276 246.114Z",
    fill: "url(#paint7_linear_1744_1286)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442.282 403.924H7.718C3.455 403.924 0 400.469 0 396.206C0 391.943 3.455 388.488 7.718 388.488H442.282C446.545 388.488 450 391.943 450 396.206C450 400.469 446.545 403.924 442.282 403.924Z",
    fill: "url(#paint8_linear_1744_1286)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M232.682 341.498H217.312C207.598 341.498 199.693 333.593 199.693 323.873V291.27H167.09C157.376 291.27 149.471 283.365 149.471 273.651V258.281C149.471 248.567 157.376 240.662 167.09 240.662H199.693V208.06C199.693 198.34 207.598 190.435 217.312 190.435H232.682C242.402 190.435 250.307 198.34 250.307 208.06V240.663H282.904C292.624 240.663 300.529 248.568 300.529 258.282V273.652C300.529 283.366 292.624 291.271 282.904 291.271H250.307V323.874C250.307 333.593 242.402 341.498 232.682 341.498ZM167.091 256.099C165.885 256.099 164.908 257.076 164.908 258.282V273.652C164.908 274.858 165.884 275.835 167.091 275.835H207.411C211.674 275.835 215.129 279.29 215.129 283.553V323.874C215.129 325.08 216.106 326.063 217.312 326.063H232.682C233.888 326.063 234.871 325.08 234.871 323.874V283.553C234.871 279.29 238.326 275.835 242.589 275.835H282.904C284.11 275.835 285.093 274.858 285.093 273.652V258.282C285.093 257.076 284.11 256.099 282.904 256.099H242.589C238.326 256.099 234.871 252.644 234.871 248.381V208.061C234.871 206.855 233.889 205.872 232.682 205.872H217.312C216.106 205.872 215.129 206.854 215.129 208.061V248.381C215.129 252.644 211.674 256.099 207.411 256.099H167.091Z",
    fill: "url(#paint9_linear_1744_1286)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M271.067 403.924C266.804 403.924 263.349 400.469 263.349 396.206V341.01C263.349 336.747 266.804 333.292 271.067 333.292C275.33 333.292 278.785 336.747 278.785 341.01V396.206C278.786 400.469 275.33 403.924 271.067 403.924Z",
    fill: "url(#paint10_linear_1744_1286)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M178.933 403.924C174.67 403.924 171.215 400.469 171.215 396.206V341.01C171.215 336.747 174.67 333.292 178.933 333.292C183.196 333.292 186.651 336.747 186.651 341.01V396.206C186.651 400.469 183.196 403.924 178.933 403.924Z",
    fill: "url(#paint11_linear_1744_1286)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1744_1286",
    x1: 453.507,
    y1: 88.3514,
    x2: -137.673,
    y2: 142.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF36A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40FBFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilySupport);
export default __webpack_public_path__ + "static/media/family-support.9dd78eb6039718ad9a2f253fcb2d27eb.svg";
export { ForwardRef as ReactComponent };